import UserToDoList from "../owner/UserToDoList";
import WaagChart from "../owner/WaagChart";
import ClinicianHoursChart from "../owner/ClinicianHoursChart";

export default function OfficeManagerDashboardComponent() {
  return (
    <div className="w-full pb-20">
      <WaagChart />
      <ClinicianHoursChart />
      <UserToDoList />
    </div>
  );
}
